/** Landing page for a support identity whose temporary access has ended. */
export const ACCESS_ENDED_PATH = "/support/access-ended";
